import * as React from 'react'
import {ReactNode} from 'react'
import {Nullable} from '../../../app/TypeHelpers'
import {HttpError} from '../../../network/errors/HttpError'
import {HttpTimeoutError} from '../../../network/errors/baseHandling/HttpTimeoutError'
import styled from 'styled-components'
import EventEmitterExResident from './EventEmitterExResident'
import {ErrorMessage, ErrorMessageTitle} from '../../assocDirector/components/MeetingCommentInputForm'
import Scroll from 'react-scroll'
import {BaseHttpError} from '../../../network/errors/baseHandling/BaseHttpError'
import {LeftColumnFlexContainer} from '../../../styledComponents/FlexComponents'

export interface HeadingAreaMessageParams {
    title: Nullable<string>
    detail: string
}

interface HeadingAreaMessageComponentProps {
    eventEmitter?: EventEmitterExResident
    params?: HeadingAreaMessageParams
    scrollRef?: React.RefObject<HTMLDivElement>
}

interface HeadingAreaMessageComponentState {
    params: Nullable<HeadingAreaMessageParams>
}

const scroller = Scroll.animateScroll

export class HeadingAreaMessageComponentForResident
    extends React.Component<HeadingAreaMessageComponentProps, HeadingAreaMessageComponentState> {

    constructor(props: Readonly<HeadingAreaMessageComponentProps>) {
        super(props)

        this.state = {
            params: null,
        }
        this.handleShowMessage = this.handleShowMessage.bind(this)
        this.handleClearMessage = this.handleClearMessage.bind(this)
    }

    componentDidMount(): void {
        if (this.props.params) {
            this.setState({
                params: null,
            })
        }
        if (!this.props.eventEmitter) {
            return
        }
        this.props.eventEmitter.on('showHeadingAreaMessage', this.handleShowMessage)
        this.props.eventEmitter.on('clearHeadingAreaMessage', this.handleClearMessage)
    }

    componentWillUnmount(): void {
        if (!this.props.eventEmitter) {
            return
        }
        this.props.eventEmitter.off('showHeadingAreaMessage', this.handleShowMessage)
        this.props.eventEmitter.off('clearHeadingAreaMessage', this.handleClearMessage)
    }

    handleShowMessage(
        paramsOrError: HeadingAreaMessageParams | HttpError | HttpTimeoutError,
    ): void {
        if (!paramsOrError) {
            return
        }

        const {
            scrollRef,
        } = this.props

        const isHeadingAreaMessageParams = (target: object) => (target as BaseHttpError).status === undefined

        const convertToHeadingAreaMessageParams = (error: HttpError): HeadingAreaMessageParams => {
            const {title, message} = error.responseBody.requestError
            return {
                title: title,
                detail: message
            }
        }

        let showParams: HeadingAreaMessageParams
        if (isHeadingAreaMessageParams(paramsOrError)) {
            showParams = (paramsOrError as HeadingAreaMessageParams)
        } else {
            showParams = convertToHeadingAreaMessageParams(paramsOrError as HttpError)
        }

        this.setState({params: showParams}, () => {
                if (!this.props.eventEmitter) {
                    return
                }

                const options = {
                    delay: 100,
                    duration: 500,
                    smooth: true,
                }

                if (scrollRef && scrollRef.current) {
                    scroller.scrollTo(scrollRef.current.offsetTop, options)
                } else {
                    scroller.scrollToTop(options)
                }
            }
        )
    }

    handleClearMessage(): void {
        this.setState({params: null})
    }

    render(): ReactNode {
        const {params} = this.state
        if (!params) {
            return null
        }
        return (
            <ErrorMessageArea id={'errorMessageArea'}>
                <ErrorMessageTitle>
                    {params.title}
                </ErrorMessageTitle>
                <ErrorMessage>
                    {params.detail}
                </ErrorMessage>
            </ErrorMessageArea>
        )
    }
}

const ErrorMessageArea = styled(LeftColumnFlexContainer)`
  background: #fbebec;
  padding: 10px;
  margin-bottom: 15px;
  gap: 5px;
`
